import(/* webpackMode: "eager" */ "/app/app/funil-evergreen/page.tsx");
